import { useEffect, useState } from "react";
import api, { fmtIDR, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Settings2 } from "lucide-react";

const FIELDS = [
  ["jht_company", "JHT Perusahaan (%)"], ["jht_employee", "JHT Karyawan (%)"],
  ["jp_company", "JP Perusahaan (%)"], ["jp_employee", "JP Karyawan (%)"],
  ["jkk", "JKK default (%)"], ["jkm", "JKM (%)"],
  ["kes_company", "BPJS Kesehatan Perusahaan (%)"], ["kes_employee", "BPJS Kesehatan Karyawan (%)"],
  ["jp_cap", "Batas Upah JP (0 = otomatis)"], ["kes_cap", "Batas Upah BPJS Kesehatan"],
  ["overtime_divisor", "Pembagi Upah Lembur"],
];
const TEXTS = [["npwp_pemotong", "NPWP Pemotong (16 digit, untuk Coretax)"], ["id_tku", "ID TKU / NITKU Pemotong (kosong = NPWP + 000000)"]];

export function BpjsSettingsDialog({ clientId }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  useEffect(() => {
    if (!open || !clientId) return;
    api.get(`/payroll/settings?client_id=${clientId}`).then(({ data }) => setF(data)).catch(() => {});
  }, [open, clientId]);
  const save = async () => {
    const payload = { client_id: clientId };
    FIELDS.forEach(([k]) => { payload[k] = Number(f[k] || 0); });
    TEXTS.forEach(([k]) => { payload[k] = f[k] || ""; });
    payload.bpjs_base = f.bpjs_base || "base";
    payload.work_week = Number(f.work_week || 5);
    try { await api.put("/payroll/settings", payload); toast.success("Pengaturan BPJS disimpan"); setOpen(false); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" data-testid="bpjs-settings-btn"><Settings2 className="h-4 w-4 mr-2" />Pengaturan BPJS & Coretax</Button></DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader><DialogTitle>Tarif & Batas Upah BPJS</DialogTitle>
          <DialogDescription className="text-xs">Berlaku untuk karyawan dengan mode BPJS otomatis. Batas upah JP otomatis saat ini: {fmtIDR(f.jp_cap_default)} (berlaku Maret 2026).</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className="space-y-1.5"><Label className="text-xs">{label}</Label>
              <Input type="number" step="0.01" className="num" value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`bpjs-set-${k}`} /></div>
          ))}
          <div className="col-span-2 space-y-1.5"><Label className="text-xs">Dasar Upah BPJS Otomatis</Label>
            <select className="w-full h-9 rounded-md border border-input bg-transparent px-2 text-sm" value={f.bpjs_base || "base"} onChange={(e) => setF({ ...f, bpjs_base: e.target.value })} data-testid="bpjs-set-base">
              <option value="base">Gaji Pokok</option><option value="base_fixed">Gaji Pokok + Tunjangan Tetap</option>
            </select></div>
          <div className="col-span-2 space-y-1.5"><Label className="text-xs">Hari Kerja per Minggu (untuk potongan absensi)</Label>
            <select className="w-full h-9 rounded-md border border-input bg-transparent px-2 text-sm" value={String(f.work_week || 5)} onChange={(e) => setF({ ...f, work_week: Number(e.target.value) })} data-testid="bpjs-set-work-week">
              <option value="5">5 hari kerja (Senin–Jumat)</option><option value="6">6 hari kerja (Senin–Sabtu)</option>
            </select></div>
          {TEXTS.map(([k, label]) => (
            <div key={k} className="col-span-2 space-y-1.5"><Label className="text-xs">{label}</Label>
              <Input value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`bpjs-set-${k}`} /></div>
          ))}
        </div>
        <DialogFooter><Button onClick={save} data-testid="bpjs-settings-save">Simpan</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
